export default __webpack_public_path__ + "static/media/replace-battery.0daccd2d.svg";